var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-content"},[_c('label',[_vm._v("Find pocket pivot with period of")]),_c('p-inputText',{style:(_vm.selectWidth),attrs:{"type":"number","min":"1"},on:{"keypress":_vm.preventDecimal},model:{value:(_vm.settings.period),callback:function ($$v) {_vm.$set(_vm.settings, "period", $$v)},expression:"settings.period"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }